<template>

    <div class="row mb-12">
        <div class="col-md-12 mb-4">
            <div class="card text-left">
                <div class="card-body">
                    <ul class="nav nav-tabs" >
                        <li class="nav-item">
                            <span style="font-size: 18px; cursor: pointer;" class="nav-link" :class="{ 'active show': activeTab === true}" @click="active()">معرفی برند ژنیران | Geniran</span>
                        </li>

                        <li class="nav-item">
                        <span  style="font-size: 18px; cursor: pointer;" class="nav-link" :class="{ 'active show': activeTab2 === true}" @click="active2()">معرفی برند دمنده | Damandeh</span>
                        </li>

                    </ul>

                    <div class="tab-content">
                        <div style="direction: rtl; text-align: right; margin-top: 10px;" class="tab-pane fade" :class="{ 'active show': activeTab === true}" >
                            <p>
                                شرکت ژنیران فن از سال 1375 تاسیس و با تولید الکتورموتور ها به روش سنتی شروع به کار کرد . بعد از یک سال و با افزایش مساحت کارخانه و گسترش دستگاه های پیشرفته و فضای محیط اقدام به تولید الکتروموتور و هواکش های صنعتی نمود.
                            </p><p>
                            هواکش ژنیران با تنوع محصولات صنعتی از جمله : هواکش صنعتی سبک 5 پر – هواکش صنعتی سنگین 6پر – هواکش صنعتی پروانه استیل – هواکش های اکسیال – هواکش های ایلکا فلزی 7 پر – هواکش ایلکای تاسیساتی ,  در سایز های 30 سانت , 35 سانت,  40 سانت ,  45 سانت ,  50 سانت ,  60سانت ,  63 سانت  ,  70 سانت ,  80 سانت و مدل موتور های سه فاز و تک فاز در دور موتور 900 دور . 1400 دور . 2800 دور . اقدام به تولید نموده است .
                        </p><p>
                            شرکت ژنیران با توجه به کیفیت محصول و نیاز مشتری دربخش صادرات هواکش به کشور های دیگر ار جمله عراق , افغانستان ,  آذربایجان و ... یکی از پیشرو های صنعت هواکش است .
                            هواکش ژنیران اقدام به کسب استاندارد ایمنی و CE  اروپا را دارا می باشد .
                            هواکش های ژنیران دارای 18 ماه ضمانت طلایی تعویضی می باشد .
                        </p>
                        </div>

                        <div style="direction: rtl; text-align: right; margin-top: 10px;" class="tab-pane fade" :class="{ 'active show': activeTab2 === true}" ><p>
                            شرکت دمنده یکی از موفق ترین شرکت های ایرانی در تولید هواکش و تهویه مطبوع است . شرکتی دارای سابقه درخشان در تولید و فروش هواکش است. شرکت دمنده در راستای محصولات و خدمات شایسته به مشتریان خود تمامی محصولات خود درای نشان استاندارد ایمنی و گواهی CE اروپا کسب کرده  و همچنین موفق به اخذ گواهی نامه سیستم مدیریت کیفیت iso 9001   را دارا می باشد .</p><p>
                            طراحی و تولیدات محصولات دمنده بر اساس نیاز بازار بومی سازی شده و از مجهزتیرین پیشرفته ترین تکنولوژی روز دنیا بکار گرفته شده است محصولات هواکش دمنده با توجه به نیاز بازار و بازار های صادرات به گروه های خانگی – صنعتی – تاسیساتی – تهویه پارکینگی تولید می شود
                            انواع مدل های محصولات دمنده شامل :
                        </p><p>
                            هواکش های سبک فلزی – هواکش صنعتی پروانه استیل – هواکش صنعتی سنگین فلزی – هواکش صنعتی ایلکا – هواکش صنعتی ایلکا فلزی – هواکش لوکس دمپر اتوماتیک – هواکش پلاستیکی خانگی – هواکش پلاستیکی آکسی لاین – هواکش خانگی اتو لوکس دمپر اتوماتیک – هواکش اکسیال گرد و چهار گوش طرح المان – هواکش فلزی خانگی – هواکش رادیال – فن بین کانالی – هواکش رادیال سقفی – سانتریفیوژ دو طرفه فوروارد – سانتریفیوژ یک طرفه بک وارد- پنکه رومیزی – فن اکسیال تاسیساتی یوروونت- فن ناتژانت – بلوور پکیچ و ....
                            تقسیم بندی می شود.
                        </p><p>
                            هواکش دمنده دارای بیش از 200 مدل هواکش در طرح ها و اندازه های مختلف است . شرکت دمنده بزرگترین و متنوع ترین محصولات هواکش و تهویه را در ایران و خاورمیانه دارا می باشد.
                            و به بیش از 20 کشور دنیا محصولات خود را صادر کرده است .
                            هواکش دمنده دارای 18 ماه ضمانت محصولات می باشد . که به هر نحوی که خرید کرده باشید و شامل 5 سال پشتیبانی قطعات می باشد .
                        </p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- Company geniran Start -->
        <br><br><br>
    </div>
</template>

<script>
    export default {
        name: "IntroductionBrand",
        data() {
            return {
                activeTab:true,
                activeTab2:false
            };
        },
        methods: {
            active() {
                    this.activeTab=true;
                    this.activeTab2=false;

                 //  window.scrollTo({
                 //   top: 0,
                 //   behavior: 'smooth'
              //  });
            },
            active2() {
                    this.activeTab=false;
                    this.activeTab2=true;
            }
        }

    }
</script>

<style scoped>

</style>
